import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddProduct = createAsyncThunk(
  "inventory/AddProduct",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/product/create/`, data)
    return response.data
  }
); 

export const UpdateProduct = createAsyncThunk(
  "inventory/UpdateProduct",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/product/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteProduct = createAsyncThunk(
  "inventory/DeleteProduct",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/product/delete/${id}/`)
    return response.status
  }
);

export const GetProducts = createAsyncThunk(
  "inventory/GetProducts",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/product/list/`);
    return data
  }
);

export const GetStockByBarcode = createAsyncThunk(
  "inventory/GetStockByBarcode",
  async (id) => {
    if(id){
      const {data} = await coreAxios.get(`${BASE_URL}/api/stock/by/barcode/${id}/`)
      return data
    }
  }
);